import { render } from "./bookingTypeSelector.vue?vue&type=template&id=6d827a4d&scoped=true"
import script from "./bookingTypeSelector.vue?vue&type=script&lang=js"
export * from "./bookingTypeSelector.vue?vue&type=script&lang=js"

import "./bookingTypeSelector.vue?vue&type=style&index=0&id=6d827a4d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d827a4d"]])

export default __exports__